import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { QuoteWithVehicleSpecification } from "../../types/Quote";

export const getQuotesWithVehicleSpecifications = (
  dossierId: string,
  quoteIds: string[],
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["quotes-with-specs", dossierId, quoteIds],
    queryFn: (): Promise<QuoteWithVehicleSpecification[]> => {
      return fetchWithAuth<QuoteWithVehicleSpecification[]>(
        "getDossierQuotesWithVehicleSpecifications",
        dossierId,
        {
          queryParams: {
            quoteIds: quoteIds ? quoteIds.join(",") : undefined,
          },
        }
      );
    },
    enabled: isQueryEnabled(options),
  });
};
